<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Készletátadások</span>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="representativeTransfer/fetchAll"
      />
    </div>
    <representative-transfer-list />
    <template v-if="$route.meta.showViewRepresentativeTransferDialog">
      <representative-transfer-dialog
        :representative-transfer-id="$route.params.id"
      />
    </template>
  </el-card>
</template>

<script>
  import RepresentativeTransferList from '../../components/representativeProcesses/representativeTransfers/List';
  import TableFilter from '../../components/TableFilter';
  import RepresentativeTransferDialog from '../../components/representativeProcesses/representativeTransfers/Dialog';

  export default {
    components: {
      RepresentativeTransferList,
      TableFilter,
      RepresentativeTransferDialog,
    },
    data() {
      return {
        loading: false,
        filterConfig: null,
      };
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {
        let storages = this.$store.getters['storage/representativeStorages'];
        if (!storages.length) {
          await this.$store.dispatch('storage/fetchAll');
          storages = this.$store.getters['storage/representativeStorages'];
        }
        this.filterConfig = [
          {
            type: 'text',
            name: 'receipt_number',
            label: 'Bizonylatszám',
            defaultSearch: true,
          },
          {
            type: 'select',
            options: [
              {
                label: 'Rögzítve',
                status: 'recorded'
              },
              {
                label: 'Átvételre vár',
                status: 'dropped'
              },
              {
                label: 'Átvéve',
                status: 'done'
              },
              {
                label: 'Visszavonva',
                status: 'cancelled'
              },
            ],
            name: 'status',
            label: 'Státusz',
            labelCallback: status => status.label,
            valueKey: 'status',
          },
          {
            type: 'select',
            options: storages,
            name: 'source_storage',
            label: 'Forrás raktár',
            labelCallback: storage => storage && storage.name || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            options: storages,
            name: 'target_storage',
            label: 'Cél raktár',
            labelCallback: storage => storage && storage.name || '',
            valueKey: 'id',
          },
        ];
      },
    },
  };
</script>
